import { ApexOptions } from "apexcharts";
// @mui
import { Box, Card, CardHeader, CardProps } from "@mui/material";
// components
import Chart, { useChart } from "..";

// ----------------------------------------------------------------------

interface Props extends CardProps {
  title?: string;
  subheader?: string;
  chart: {
    categories?: string[];
    colors?: string[];
    series: {
      data: {
        name: string;
        data: number[];
      }[];
    }[];
    options?: ApexOptions;
  };
}

export default function AreaChart({ title, subheader, chart, ...other }: Props) {
  const { colors, categories, series, options } = chart;

  const chartOptions = useChart({
    colors,
    xaxis: {
      categories,
    },
    ...options,
  });

  return (
    <>
      {series.map((item, index) => (
        <Box key={index}>
          <Chart type="area" series={item.data} options={chartOptions} height={365} />
        </Box>
      ))}
    </>
  );
}
